/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DistributeSkillRequestBody,
  DistributeSkillRequestBody$Outbound,
  DistributeSkillRequestBody$outboundSchema,
} from "../components/distributeskillrequestbody.js";

export type DistributeSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DistributeSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DistributeSkillSecurity = {
  option1?: DistributeSkillSecurityOption1 | undefined;
  option2?: DistributeSkillSecurityOption2 | undefined;
};

export type DistributeSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  distributeSkillRequestBody: DistributeSkillRequestBody;
};

/** @internal */
export type DistributeSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DistributeSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  DistributeSkillSecurityOption1$Outbound,
  DistributeSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function distributeSkillSecurityOption1ToJSON(
  distributeSkillSecurityOption1: DistributeSkillSecurityOption1,
): string {
  return JSON.stringify(
    DistributeSkillSecurityOption1$outboundSchema.parse(
      distributeSkillSecurityOption1,
    ),
  );
}

/** @internal */
export type DistributeSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DistributeSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  DistributeSkillSecurityOption2$Outbound,
  DistributeSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function distributeSkillSecurityOption2ToJSON(
  distributeSkillSecurityOption2: DistributeSkillSecurityOption2,
): string {
  return JSON.stringify(
    DistributeSkillSecurityOption2$outboundSchema.parse(
      distributeSkillSecurityOption2,
    ),
  );
}

/** @internal */
export type DistributeSkillSecurity$Outbound = {
  Option1?: DistributeSkillSecurityOption1$Outbound | undefined;
  Option2?: DistributeSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DistributeSkillSecurity$outboundSchema: z.ZodMiniType<
  DistributeSkillSecurity$Outbound,
  DistributeSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DistributeSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DistributeSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function distributeSkillSecurityToJSON(
  distributeSkillSecurity: DistributeSkillSecurity,
): string {
  return JSON.stringify(
    DistributeSkillSecurity$outboundSchema.parse(distributeSkillSecurity),
  );
}

/** @internal */
export type DistributeSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DistributeSkillRequestBody: DistributeSkillRequestBody$Outbound;
};

/** @internal */
export const DistributeSkillRequest$outboundSchema: z.ZodMiniType<
  DistributeSkillRequest$Outbound,
  DistributeSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    distributeSkillRequestBody: DistributeSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      distributeSkillRequestBody: "DistributeSkillRequestBody",
    });
  }),
);

export function distributeSkillRequestToJSON(
  distributeSkillRequest: DistributeSkillRequest,
): string {
  return JSON.stringify(
    DistributeSkillRequest$outboundSchema.parse(distributeSkillRequest),
  );
}
